import React from 'react';

import gridWidth from '../shared/grid-width';

import { PrismicRichContent, PrismicImage } from '../../../../../types';

import * as S from './styles';

type Props = {
  text: Array<PrismicRichContent>;
  image: PrismicImage;
  reverse?: boolean;
  gridLayout: string;
};

const ImageText = ({ text, image, reverse = false, gridLayout }: Props) => {
  const width = gridWidth(gridLayout);

  return (
    <S.ImageText reverse={reverse}>
      <S.Image {...image} width={width[reverse ? 1 : 0]} reverse={reverse} />
      <S.Text data={text} width={width[reverse ? 0 : 1]} reverse={reverse} />
    </S.ImageText>
  );
};

export default ImageText;
